<template>
    <div class="pli-bundled-products mt-3">
        <button
            class="btn btn-text collapsed"
            type="button"
            data-toggle="collapse"
            :data-target="'#bundled-products' + productUuid"
            aria-expanded="false"
            :aria-controls="'bundled-products' + productUuid"
        >
            <span v-html="$t('label.viewxitems', [bundledProducts.length])"></span>
            <span class="icon-chevron">
                <svg class="svg-icon chevron-svg  decorative-icon" aria-label="chevron" focusable="false" aria-hiddn="true" role="img">
                    <use :href="`${svgPath}#chevron`" />
                </svg>
            </span>
        </button>
        <div class="collapse" :id="'bundled-products' + productUuid">
            <div
                v-for="(bundledProduct, index) in bundledProducts"
                :key="bundledProduct.UUID"
                :class="'pli-bundled-item d-flex ' + (index === 0 ? 'mt-3' : '')"
            >
                <div class="flex-grow-0">
                    <img
                        class="pli-image"
                        :src="bundledProduct.imagesCart.cart_thumbnail[0].url"
                        :alt="bundledProduct.imagesCart.cart_thumbnail[0].alt"
                        :title="bundledProduct.imagesCart.cart_thumbnail[0].title"
                    />
                </div>
                <div class="pl-3">
                    <div class="pli-product-details">
                        <div class="pli-product-name"> {{ bundledProduct.productName }} </div>

                        <!-- ProductAttributes -->
                        <div
                            v-for="attribute in bundledProduct.variationAttributes"
                            :key="attribute.name"
                            class="pli-product-attributes font-weight-light" tabindex="0"
                        >
                            {{ attribute.displayName }}: {{ attribute.displayValue }}
                        </div>

                        <div class="line-item-quantity">
                            <span class="body-alt text-capitalize" v-html="$t('label.orderdetails.Qty')"></span>
                            <span class="body-alt">{{ bundledProduct.quantity }}</span>
                        </div>
                        <div v-if="bundledProduct.isHazardousMaterial" class="hazardous-alert-icon-wrapper">
                            <svg class="hazardous-alert-icon">
                            <use :href="`${svgPath}#hazardous-alert`" />
                            </svg>
                        </div>
                        <!-- Restricted shipping items -->
                        <div v-if="bundledProduct.isExcludedProduct" class="pli-product-restricted">
                            <span>{{ bundledProduct.excludedProductMessage }}</span>
                        </div>
                        <!-- Restricted shipping items -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "BundleLineItem",
        components: {},
        props: {
            bundledProducts: {
                type: Array,
                required: true,
            },
            productUuid: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                translate: this.$t.bind(this)
            };
        },
        methods: {},
        computed: {
            ...mapState(["svgPath"])
        },
        created() {},
    };
</script>